import OverlayPGIS from "@/plugin/gis-viewer/widgets/Overlays/pgis/OverlayPGIS";
import { IResult, ITrackPlaybackPGIS } from "@/types/map";

declare let ol: any;
export default class TrackPlaybackPGIS {
  private static instances: Map<string, any>;
  private view: any;
  private fmap: any;
  private uuid: any;

  private constructor(view: any, fmap: any) {
    this.view = view;
    this.fmap = fmap;
  }

  public static getInstance(view: any, fmap: any) {
    let id = view.getTarget();
    if (!TrackPlaybackPGIS.instances) {
      TrackPlaybackPGIS.instances = new Map();
    }
    let instance = TrackPlaybackPGIS.instances.get(id);
    if (!instance) {
      instance = new TrackPlaybackPGIS(view, fmap);
      TrackPlaybackPGIS.instances.set(id, instance);
    }
    return instance;
  }

  public async startTrackPlayback(
    params: ITrackPlaybackPGIS
  ): Promise<IResult> {
    const trackPoints = params.trackPoints;
    const speed = params.speed || 100;
    const carSymbol: any = params.carSymbol || {};
    const lineSymbol = params.trackLineSymbol || undefined;
    const loop = params.loop === true;

    if (this.uuid) {
      await this.stopTrackPlayback();
    }
    const addTrackLine = OverlayPGIS.getInstance(this.view, this.fmap);
    await addTrackLine.addOverlays({
      type: "trackPlayback_trackLine",
      overlays: [
        {
          id: "trackLine",
          geometry: { paths: trackPoints },
          symbol: {
            type: "polyline",
            color: lineSymbol?.color ? lineSymbol.color : "rgb(8,146,251)",
            width: 10,
          },
          fields: { name: "测试1", featureid: "0002" },
        },
      ],
    });

    trackPoints.map((trackPt) => {
      return trackPt.push(5);
    });
    const trackPlaybackParams = {
      //必填
      coordinates: trackPoints,
      name: "线路1", //非必填
      style: {
        //非必填
        customIcon: carSymbol.url ? carSymbol?.url : "", //Cesium的2D、3D模式下支持gltf模型，Openlayers只支持png jpg路径
        fontFamily: "微软雅黑", //√字体
        color: "rgba(0,255,0,1)", //√字体颜色
        bgColor: "rgba(255,255,255,0.2)", //√文字背景颜色（含透明度）rgba模式
        fontSize: 18, //√字体大小
        heading: 0, //方向角  模型的方向角，顺指针，正北为0。Cesium优先采用gltf模型作为移动对象，如果是图片对象则体验度不好（图片是立体的，）
        size: 10, //模型大小（比例缩放） 如果样式为3D模型
        anchor: [0.5, 0.5], //图片锚点位置，默认为[0.5,1]表示锚点在图片正下方
        //[0.5,0.5]也是常用的参数（表示锚点在图片正中），可以将图片正中定位到坐标点
        //如小车模型图片则应该设置锚点为正中，带针尖的marker图表则应该设置锚点为正下方
      },
      attr: {
        //非必填
        cameraType: "", //"dy"://锁定第一视角  "sd"://锁定上帝视角  "gs"://跟随视角 "":自由
        speed: speed, //速度 公里每小时  非必填默认为60
        clockRange: loop, //是否循环显示
        showLabel: false, //显示标注
        showLine: false, //显示线条
        height: 2000, //飞行高度
      },
      interval: 10, //位置改变过程中，回调事件接收消息的时间间隔，默认10毫秒
    };

    const uuid = this.fmap.moveOnLine(trackPlaybackParams, (data: any) => {});
    this.uuid = uuid;

    return {
      status: 0,
      message: "成功调用startTrackPlayback方法！",
    };
  }

  public async stopTrackPlayback(): Promise<IResult> {
    if (this.uuid) {
      this.fmap.removeAllGraphic();
    }
    const addTrackLine = OverlayPGIS.getInstance(this.view, this.fmap);
    addTrackLine.deleteOverlays({
      types: ["trackPlayback_trackLine"],
    });
    return {
      status: 0,
      message: "成功调用stopTrackPlayback方法！",
    };
  }

  private getStyle(params: any): any {
    const symbol = params;
    let vectorStyle: any = null;
    switch (symbol.type) {
      case "point":
        if (symbol.primitive) {
          const radius = symbol.size || 5;
          const color = symbol.color || "#c0ad00";
          vectorStyle = new ol.style.Style({
            image: new ol.style.Circle({
              radius: radius,
              fill: new ol.style.Fill({
                color: color,
              }),
            }),
          });
        } else {
          const src = symbol.url;
          const size: any = symbol.size || [];
          const offset: any = [symbol.xoffset, symbol.yoffset] || [];
          if (!src || typeof src !== "string") {
            return {
              status: 0,
              message: "点url属性错误！",
            };
          }
          const img = new ol.style.Icon({
            src: src,
          });
          vectorStyle = new ol.style.Style({});
          vectorStyle.setImage(img);
          // if(size.length && typeof size[0] === "number"){
          //   // let imgSize = img.getSize();
          //   // imgSize = ol.size.toSize(size)
          // }
          if (offset.length && typeof offset[0] === "number") {
            img.offset = offset;
            vectorStyle.setImage(img);
          }
        }
        break;
      case "polyline":
        const color = symbol.color;
        const width = symbol.width;
        const plStroke = new ol.style.Stroke({
          color: "rgb(0,253,50)",
          width: 5,
        });
        vectorStyle = new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: "rgb(0,253,50)",
            width: 5,
          }),
        });
        if (color) {
          plStroke.setColor(color);
          vectorStyle.setStroke(plStroke);
        }
        if (width) {
          plStroke.setWidth(width);
          vectorStyle.setStroke(plStroke);
        }
        break;
      case "polygon":
        const polygonColor = symbol.color;
        const outline = symbol.outline;
        vectorStyle = new ol.style.Style({});
        const olStroke = new ol.style.Stroke({
          color: "rgb(0,0,0)",
          width: 0.1,
        });
        const fill = new ol.style.Fill({
          color: "rgba(0,208,254,0.5)",
        });
        if (outline && outline.color) {
          olStroke.setColor(outline.color);
          vectorStyle.setStroke(olStroke);
        }
        if (outline && outline.width) {
          olStroke.setWidth(outline.width);
          vectorStyle.setStroke(olStroke);
        }
        if (polygonColor) {
          fill.setColor(polygonColor);
          vectorStyle.setFill(fill);
        }
        break;
      default:
        break;
    }
    return vectorStyle;
  }
}
